import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import { Link, useNavigate , useLocation } from "react-router-dom";
import { AuthContext, base_url } from "../context/Authcontext";
import LoginReg from "./LoginReg";
import axios from "axios";
import ToastMessage from "./ToastMessage";
import toast from "react-hot-toast";

export const Header = ({ isSidebar, setSidebar, refreshHeader }) => {
  const navigate=useNavigate();
  const location = useLocation();
  const activeOneClickBtn=useRef(null);
  const [active, setactive] = useState(false);
  const [regactive, setregactive] = useState(false);
  const {logout, userdata, isAuthenticated } =
    useContext(AuthContext);
  const [sidebaar, setsidebaar] = useState(false);
  const [userid, setuserid] = useState({userName:"",userPhone:""});
  const [userBal,setUserBal]=useState({userTotalBal:0,bonus:0});
  const [activeLink, setActiveLink] = useState(null);
  const [isOneClickBet,setIsOneClickBet]=useState(false);
  const [refresh,setRefresh]=useState(false);
  const [liability, setLiability] = useState('0');
  const [aviator, setAviator]= useState();
  const [ludo, setLudo]= useState();

  
// console.log("rejective sis", regactive)
  const handleHamburger = () => {
    setSidebar(!isSidebar);
   
    // console.log("dide bar ", isSidebar);
    
  };


  const handleSubmit= async()=>{
    const token=localStorage.getItem('game_token');
    try{
      const response= await axios.post(base_url + '/api/webapi/casinoLobby',{token},
        {
          withCredentials:true,
          headers:{
            'content-type':'application/json',
          }
        }
      )
  
      // console.log('lobby',response);
      if(response?.data.success){
        window.location.href=response?.data.url;
      }else{
        toast.error(response?.data.message);
      }
  
    }catch(err){
      console.log(err);
    }
  }

  const handleGames= async()=>{
    try{
      const token=localStorage.getItem('game_token');
      const response = await axios.get(base_url + '/api/webapi/particularGame', {
        params:{
          token,
          provider:'SPB',
        },
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        },
      });
      // console.log('games',response?.data);
      const games= response?.data?.items;

      const avia= games?.filter(game=>game?.name.includes('Aviator'));
      // console.log('aviator',avia[0]);
      const id=avia[0]?.id;
      setAviator(id);

    }catch(err){
      console.log(err);
    }
  }

  const handleGames1= async()=>{
    try{
      const token=localStorage.getItem('game_token');
      const response = await axios.get(base_url + '/api/webapi/particularGame', {
        params:{
          token,
          provider:'JIL',
        },
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        },
      });
      // console.log('games',response?.data);

      const games= response?.data?.items;

      const avia= games?.filter(game=>game?.name.includes('Ludo'));
      // console.log('ludo',avia[0]);
      const id=avia[0]?.id;
      setLudo(id);
    }catch(err){
      console.log(err);
    }
  }

  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
      if(!isAuthenticated){
        toast.error("Please Login to Play Games.");
        setactive(true);
        return;
      }

      const token= localStorage.getItem('game_token');
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error(response?.data.message);
        }


    }catch(err){
        console.log(err);
    }
  }

  
  const handleClick = (linkName) => {
    setActiveLink((prev) => (prev === linkName ? null : linkName));
  };
 const handleOneClickBtn=(e)=>{
  e.preventDefault();
  document.querySelector('.active_one_click')?.classList.remove('active_one_click');
  if (activeOneClickBtn.current) {
    
    activeOneClickBtn.current.classList.remove("active_one_click");
  }
  e.target.classList.add("active_one_click");
  activeOneClickBtn.current = e.target;

 }


//  handle bonus
const handleClaimBonus=async()=>{
  try{
    if(userBal.bonus===0){
      return;
    }
    const TotalUpdatedMoney=parseInt(userBal.userTotalBal)+(70/100)*userBal.bonus;
    const user_phone=userid.userPhone;

    const res= await axios.post(`${base_url}/api/webapi/admin/updateBonus`,
      {TotalUpdatedMoney,user_phone},
      {
        withCredentials:true,
        headers:{
          Accept:'application/json'
        }
      }
    )

    if(res?.success){
      setRefresh(!refresh);
      ToastMessage(1,res.message);
    }
  }catch(err){
    console.log(err);
  }
}

  useEffect(() => {
  
    if (isAuthenticated){
      userdata(function (res) {
        if (res?.status) {
          let data = res.data;
          setUserBal({userTotalBal:data.money_user,bonus:data.bonus_money});
          setuserid({userName:data.name_user,userPhone:data.phone_user});
        }
      });
    }
   
  }, [userdata,refresh,refreshHeader]);



  useEffect(() => {
    const LiabilityBalance = async () => {
      try {
        const response = await axios.get(`${base_url}/get/liability`, {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        });
  
        if (response?.data?.data?.totalLiability) {
          setLiability(response?.data?.data?.totalLiability);
        } else {
          setLiability('0');
        }
      } catch (error) {
        setLiability('0');
      }
    };
  
    // Call immediately on mount
    LiabilityBalance();
    handleGames();
    handleGames1();
  
    // Set up interval
    const interval = setInterval(() => {
      LiabilityBalance();
    }, 5000); // 5 seconds
  
    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, []);
  
  return (
    <>
      {<LoginReg active={active} setactive={setactive} regactive={regactive} setregactive={setregactive}/>}
      <div _ngcontent-jrx-c95="" className="nav-landing justify-content-sm-between gap-2 ">
        <div _ngcontent-mkq-c111="" className="site_logo">
          <div _ngcontent-mkq-c111="" className="site_menu">
            <div _ngcontent-mkq-c111="" className="header_menu_bar">
              {!isSidebar && (
                <Link
                  _ngcontent-mkq-c111=""
                  data-target="nav-mobile"
                  className="sidenav-trigger"
                  onClick={handleHamburger}
                >
                  <img
                    _ngcontent-mkq-c111=""
                    src="/assets/images/hamburger.svg"
                    alt="humburger_Kheloyaar360"
                    className="ng-star-inserted"
                    style={{ width: "70%" }}
                  />
                </Link>
              )}
              {isSidebar && (
                <Link
                  _ngcontent-mkq-c111=""
                  data-target="nav-mobile"
                  className="sidenav-trigger"
                  onClick={handleHamburger}
                >
                  <img
                    _ngcontent-mkq-c111=""
                    src="/assets/images/Xcross.svg"
                    alt="humburger_Kheloyaar360"
                    className="ng-star-inserted"
                    style={{ width: "70%" }}
                  />
                </Link>
              )}
            </div>
          </div>
          <Link
            to="/"
            _ngcontent-mkq-c111=""
            id="logo-container"
            routerlink="/home"
            className="brand-logo"
            style={{ marginLeft: "5px" }}
            href="/"
          >
            <img
              _ngcontent-mkq-c111=""
              className="menu_icon ng-star-inserted"
              src="/assets/images/bigshot11logonew.png"
              alt="Logo_Kheloyaar360"
              style={{ width: "100%" }}
            />
          </Link>
        </div>

        {location.pathname !== '/casinoGames' && location.pathname !== '/deposit' && location.pathname !== '/changepassword' && location.pathname !== '/sports_bets' && location.pathname !== '/withdraw' && (
        <div _ngcontent-xjv-c80="" className="side-toggle">
          <Link
            _ngcontent-xjv-c80=""
            data-toggle="collapse"
            id="sidebarCollapse"
            onClick={handleHamburger}
            className="ng-star-inserted"
          >
            <label _ngcontent-xjv-c80="" className="ng-star-inserted">
              <input _ngcontent-xjv-c80="" type="checkbox" id="check" />
              <img
                _ngcontent-xjv-c80=""
                className="w-100 hover-color-change"
                style={{filter:'filter: invert(1) grayscale(70%) contrast(80%)'}}
                alt=""
                src="https://dabba.b-cdn.net/global/hamburger.svg"
              />
            </label>
          </Link>
        </div>
        )}
       
        {/* {!isSidebar ? (
  <div className="logoo">
    <img
      src="https://dabba.b-cdn.net/kheloyar/KheloyarLogoo.png"
      alt="All Casinos_Kheloyaar360"
      width={180}
    />
  </div>
) : null} */}

<div className="d-flex overflow-x-auto  gap-5 text-nowrap "  >


  {location.pathname !== '/' && (
    <div
      _ngcontent-jrx-c95=""
      className="navItems-landing ng-star-inserted"
      onClick={()=>navigate('/')}
      style={{
  marginLeft: window.location.pathname === '/casinoGames' ? '50px' : '0px'
  }}
      
    >
      
      <img
        _ngcontent-jrx-c95=""
        // src="https://dabba.b-cdn.net/kheloyaar360.net/banners/9203.png"
        src="/assets/headerimg/h1.svg"
        alt="All Casinos_Kheloyaar360"
      />
      <span _ngcontent-jrx-c95="" className="change-color-hover" >Home</span>
    </div>
  )}

        <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>navigate('/inplayMatches')}
        >
          <img
            _ngcontent-jrx-c95=""
            src="/assets/headerimg/h2.svg"
            alt="All Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover" >In Play</span>
        </div>
        {/* <div

          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>toast.success('coming soon')}
        
        >
          <img
            _ngcontent-jrx-c95=""
            src="/assets/headerimg/h3.svg"
            alt="All Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover" >Sport Book</span>
        </div> */}
        
        <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted text-no-wrap"
          onClick={()=>openGameById(aviator)}
        >
          <img
            _ngcontent-jrx-c95=""
            src="/assets/headerimg/h4.svg"
            alt="Aviator_Kheloyaar360"
            style={{ filter: "brightness(0) saturate(100%)" }}
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover" >Aviator</span>
        </div>
      
        <div
  _ngcontent-jrx-c95=""
  className="navItems-landing ng-star-inserted"
  onClick={()=>navigate('/casinoGames', {state:{list:5}})}
>
  <img
    _ngcontent-jrx-c95=""
    src="/assets/headerimg/h5.svg"
    alt="Live Casinos_Kheloyaar360"
    className=""
  />
  <span _ngcontent-jrx-c95="" className="change-color-hover text-nowrap">Indian Casinos</span>
         </div>

         <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>navigate('/casinoGames',{state:{list:4}})}
        >
          <img
            _ngcontent-jrx-c95=""
            src="/assets/headerimg/h13.svg"
            alt="Live Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover text-nowrap" >Teen Patti</span>
        </div>

        <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>toast.success("Coming soon")}
        >
          <img
            _ngcontent-jrx-c95=""
              src="/assets/headerimg/h6.svg"
            alt="Live Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover" >Esports</span>
        </div>

        <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>handleSubmit()}
        >
          <img
            _ngcontent-jrx-c95=""
            src="/assets/headerimg/h7.svg"
            alt="Live Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover" >Casino</span>
        </div>
        
        <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>openGameById(ludo)}
        >
          <img
            _ngcontent-jrx-c95=""
            src="/assets/headerimg/h8.svg"
            alt="Live Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover" >Ludo</span>
        </div>
        <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>navigate('/cricketreal')}
        >
          <img
            _ngcontent-jrx-c95=""
            src="/assets/headerimg/h9.svg"
            alt="Live Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover" >Cricket</span>
        </div>
        <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>navigate('/footballreal')}
        >
          <img
            _ngcontent-jrx-c95=""
            src="/assets/headerimg/h10.svg"
            alt="Live Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover" >Football</span>
        </div>
        <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>toast.success("Coming soon")}
        >
          <img
            _ngcontent-jrx-c95=""
           src="/assets/headerimg/h11.svg"
            alt="Live Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover text-nowrap" >Horse Racing</span>
        </div>
        <div
          _ngcontent-jrx-c95=""
          className="navItems-landing ng-star-inserted"
          onClick={()=>toast.success("Coming soon")}
        >
          <img
            _ngcontent-jrx-c95=""
            src="/assets/headerimg/h12.svg"
            alt="Live Casinos_Kheloyaar360"
            className=""
          />
          <span _ngcontent-jrx-c95="" className="change-color-hover text-nowrap" >Greyhound Racing</span>
        </div>
       
     
</div>


        
        
        <div _ngcontent-jrx-c95="" className="landingNavbar">
          <app-nav-right _ngcontent-jrx-c95="" _nghost-jrx-c67="">
            <ul _ngcontent-jrx-c67="" className="navbar-nav">
              <li
                _ngcontent-jrx-c67=""
                className="nav-item mr-2 mt-3"
                style={{ display: "none" }}
              >
                <Link _ngcontent-jrx-c67="" href="/">
                  <svg
                    _ngcontent-jrx-c67=""
                    className="svg-inline--fa fa-bell fa-w-14"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="bell"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    data-fa-i2svg=""
                  >
                    <path
                      fill="currentColor"
                      d="M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
                    ></path>
                  </svg>
                </Link>
              </li>
              {isAuthenticated && (
                <app-payment-method _ngcontent-feu-c67="" _nghost-feu-c65="" className=''>
                  <ul
                    _ngcontent-feu-c65=""
                    className="navbar-nav payment-nav ng-star-inserted"
                  >
                    <li
                      _ngcontent-feu-c65=""
                      className="nav-item d-flex align-items-center ng-star-inserted"
                    >
                      <div
                        _ngcontent-feu-c65=""
                        className="depositButton d-flex align-items-center"
                      >
                        <Link
                          to="/deposit"
                          _ngcontent-feu-c65=""
                          className="depositWrapper"
                        >
                          <img
                            _ngcontent-feu-c65=""
                            alt="dep"
                            className="imgdeposit"
                            src="/assets/images/cash1.svg"
                          />
                          <span _ngcontent-feu-c65="">Deposit </span>
                        </Link>
                      </div>
                    </li>
                    <li
                      _ngcontent-feu-c65=""
                      className="nav-item"
                      style={{
                        marginRight: "2px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div _ngcontent-feu-c65="" className="nav-box">
                        <span _ngcontent-feu-c65="" className="nav-box-label">
                          Liability:
                        </span>
                        <span
                          _ngcontent-feu-c65=""
                          className="nav-box-amount"
                          style={{ color: "crimson" }}
                        >
                          {liability}
                        </span>
                      </div>
                    </li>
                    <li
                      _ngcontent-feu-c65=""
                      className="nav-item"
                      style={{
                        marginRight: "2px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        _ngcontent-feu-c65=""
                        className="nav-box flex-row bal-padding"
                      >
                        <div
                          _ngcontent-feu-c65=""
                          className="nav-box balance-border"
                        >
                          <span _ngcontent-feu-c65="" className="nav-box-label">
                            Balance:
                          </span>
                          <span
                            _ngcontent-feu-c65=""
                            className="nav-box-amount"
                            style={{ color: "#fff" }}
                          >
                            {userBal.userTotalBal}
                          </span>
                        </div>
                      </div>
                    </li>

                    <li
                      _ngcontent-feu-c67=""
                      className="nav-item setting-dropdown ng-star-inserted"
                    >
                      <div
                        _ngcontent-feu-c67=""
                        ngbdropdown=""
                        className="drp-user dropdown"
                      >
                        <Link
                          _ngcontent-feu-c67=""
                          onClick={() => setsidebaar((prevState) => !prevState)}
                        >
                          <img
                            _ngcontent-feu-c67=""
                            alt="cog"
                            style={{ width: "32px", marginRight: "10px" }}
                            src="/assets/images/cog2.svg"
                            className="drop_down_icon"
                            id="rotate_setting"
                          />
                        </Link>
                        <div
                          _ngcontent-feu-c67=""
                          ngbdropdownmenu=""
                          className={`dropdown-menu dropdown-menu-right profile-notification collapse bg-dark ${
                            sidebaar ? "show" : ""
                          }`}
                          x-placement="bottom-right"
                        >
                          <div
                            _ngcontent-feu-c67=""
                            className="dropdown-item theme-drop"
                          >
                            <div
                              _ngcontent-feu-c67=""
                              className="d-flex align-items-center justify-content-center border-bottom flex-column p-2"
                            >
                              <span _ngcontent-feu-c67="">{userid.userName}</span>
                            </div>
                          </div>
                          <span
                            _ngcontent-feu-c67=""
                            className="d-flex justify-content-start flex-column mx-3"
                          >
                            <span
                              _ngcontent-feu-c67=""
                              className="customMargin"
                            >
                              Balance Information
                            </span>
                            <div
                              _ngcontent-feu-c67=""
                              className="d-flex flex-row justify-content-between"
                            >
                              <span _ngcontent-feu-c67="">
                                Available Credit :{" "}
                              </span>
                              <span
                                _ngcontent-feu-c67=""
                                style={{ color: "rgb(20, 220, 37)" }}
                              >
                                {userBal.userTotalBal}
                              </span>
                            </div>
                            <span
                              _ngcontent-feu-c67=""
                              className="d-flex flex-row justify-content-between"
                            >
                              {" "}
                              Liability :{" "}
                              <span
                                _ngcontent-feu-c67=""
                                style={{ color: "crimson" }}
                              >
                               {liability}
                              </span>
                            </span>
                           
                          </span>
                          <span _ngcontent-feu-c67="" className="cusDW">
                            <Link
                              to="/deposit"
                              _ngcontent-feu-c67=""
                              className="DW-buttons"
                            >
                              {" "}
                              Deposit{" "}
                            </Link>
                            <Link
                              to="/withdraw"
                              _ngcontent-feu-c67=""
                              className="DW-buttons"
                            >
                              Withdraw{" "}
                            </Link>
                            
                          </span>
                          <div
                            _ngcontent-feu-c67=""
                            className="border-bottom mx-2"
                          ></div>

                         

                          {isOneClickBet && <div
                            _ngcontent-mcx-c93=""
                            className="ocbValueButtons ng-star-inserted"
                          >
                            <div _ngcontent-mcx-c93="" className="radioButton">
                              <label _ngcontent-mcx-c93="" htmlFor="700" onClick={handleOneClickBtn}>
                                <input
                                  _ngcontent-mcx-c93=""
                                  type="radio"
                                  name="alignment1"
                                  className="peer radio"
                                  id="700"
                                  value="700"
                                />
                                <div
                                  _ngcontent-mcx-c93=""
                                  className={`icon fs-14 active_one_click`}
                                >
                                  {" "}
                                  700{" "}
                                </div>
                              </label>
                              <label _ngcontent-mcx-c93="" for="300" onClick={handleOneClickBtn}>
                                <input
                                  _ngcontent-mcx-c93=""
                                  type="radio"
                                  name="alignment2"
                                  className="peer radio"
                                  id="300"
                                  value="300"
                                />
                                <div
                                  _ngcontent-mcx-c93=""
                                  className="icon fs-14"
                                >
                                  {" "}
                                  300{" "}
                                </div>
                              </label>
                              <label _ngcontent-mcx-c93="" for="50" onClick={handleOneClickBtn}>
                                <input
                                  _ngcontent-mcx-c93=""
                                  type="radio"
                                  name="alignment3"
                                  className="peer radio"
                                  id="50"
                                  value="50"
                                />
                                <div
                                  _ngcontent-mcx-c93=""
                                  className="icon fs-14"
                                >
                                  {" "}
                                  50{" "}
                                </div>
                              </label>
                              <label _ngcontent-mcx-c93="" for="2000" onClick={handleOneClickBtn}>
                                <input
                                  _ngcontent-mcx-c93=""
                                  type="radio"
                                  name="alignment4"
                                  className="peer radio"
                                  id="2000"
                                  value="2000"
                                />
                                <div
                                  _ngcontent-mcx-c93=""
                                  className="icon fs-14"
                                >
                                  {" "}
                                  2,000{" "}
                                </div>
                              </label>
                              <label _ngcontent-mcx-c93="" for="3000" onClick={handleOneClickBtn}>
                                <input
                                  _ngcontent-mcx-c93=""
                                  type="radio"
                                  name="alignment5"
                                  className="peer radio"
                                  id="3000"
                                  value="3000"
                                />
                                <div
                                  _ngcontent-mcx-c93=""
                                  className="icon fs-14"
                                >
                                  {" "}
                                  3,000{" "}
                                </div>
                              </label>
                              <label _ngcontent-mcx-c93="" for="4000" onClick={handleOneClickBtn}>
                                <input
                                  _ngcontent-mcx-c93=""
                                  type="radio"
                                  name="alignment6"
                                  className="peer radio"
                                  id="4000"
                                  value="4000"
                                />
                                <div
                                  _ngcontent-mcx-c93=""
                                  className="icon fs-14"
                                >
                                  {" "}
                                  4,000{" "}
                                </div>
                              </label>
                              <label _ngcontent-mcx-c93="" for="5000" onClick={handleOneClickBtn}>
                                <input
                                  _ngcontent-mcx-c93=""
                                  type="radio"
                                  name="alignment7"
                                  className="peer radio"
                                  id="5000"
                                  value="5000"
                                />
                                <div
                                  _ngcontent-mcx-c93=""
                                  className="icon fs-14"
                                >
                                  {" "}
                                  5,000{" "}
                                </div>
                              </label>
                              <label _ngcontent-mcx-c93="" for="100000" onClick={handleOneClickBtn}>
                                <input
                                  _ngcontent-mcx-c93=""
                                  type="radio"
                                  name="alignment8"
                                  className="peer radio"
                                  id="100000"
                                  value="100000"
                                />
                                <div
                                  _ngcontent-mcx-c93=""
                                  className="icon fs-14"
                                >
                                  {" "}
                                  100,000{" "}
                                </div>
                              </label>
                            </div>
                            <div
                              _ngcontent-mcx-c93=""
                              className="one-click-buttons"
                            >
                              <div
                                _ngcontent-mcx-c93=""
                                routerlink="/reports/stakebuttons"
                                className="custom"
                                tabIndex="0"
                              >
                                {" "}
                                Edit Bet Stake{" "}
                              </div>
                              <div
                                _ngcontent-mcx-c93=""
                                className="custom save"
                              >
                                {" "}
                                Save{" "}
                              </div>
                            </div>
                          </div>}

                          <Link
                            _ngcontent-feu-c67=""
                            onClick={() => handleClick("payments")}
                            className="dropDown_settings ng-star-inserted"
                          >
                            <img
                              _ngcontent-feu-c67=""
                              src="/assets/images/Credit card payment.svg"
                              alt=""
                            />{" "}
                            Payments{" "}
                            <div
                              _ngcontent-feu-c67=""
                              className="img-containers"
                            >
                              <img
                                _ngcontent-feu-c67=""
                                src="/assets/images/arrow.png"
                                className="arrows mt-0 ng-star-inserted"
                                alt="dude"
                                style={{
                                  transform:
                                    activeLink === "payments"
                                      ? "rotate(90deg)"
                                      : "rotate(0deg)",
                                }}
                              />
                            </div>
                          </Link>
                          {activeLink === "payments" && (
                            <div
                              _ngcontent-feu-c67=""
                              className="casinoesLink ng-star-inserted"
                            >
                              <Link
                                to='/deposit'
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                               

                              >
                                <span _ngcontent-feu-c67="">Deposite</span>
                              </Link>
                              <Link
                                to='/withdraw'
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                              >
                                <span _ngcontent-feu-c67="">Withdraw</span>
                              </Link>
                              <Link
                                to="/sports_bets" 
                                state={{ active: 3 }} 
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row text-nowrap"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                              >
                                <span _ngcontent-feu-c67="" className="text-wrap">
                                  Deposit/Withdraw Request History
                                </span>
                              </Link>
                            </div>
                          )}
                          <Link
                            onClick={() => handleClick("reports")}
                            _ngcontent-feu-c67=""
                            className="dropDown_settings"
                          >
                            <img
                              _ngcontent-feu-c67=""
                              src="/assets/images/accstatement.svg"
                              alt=""
                            />{" "}
                            Reports{" "}
                            <div
                              _ngcontent-feu-c67=""
                              className="img-containers"
                            >
                              <img
                                _ngcontent-feu-c67=""
                                alt="dude"
                                src="/assets/images/arrow.png"
                                className="arrows mt-0 ng-star-inserted"
                                style={{
                                  transform:
                                    activeLink === "reports"
                                      ? "rotate(90deg)"
                                      : "rotate(0deg)",
                                }}
                              />
                            </div>
                          </Link>
                          {activeLink === "reports" && (
                            <div
                              _ngcontent-feu-c67=""
                              className="casinoesLink ng-star-inserted"
                            >
                              <div
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                                onClick={()=>navigate("/sports_bets")}
                              >
                                <span _ngcontent-feu-c67="">My Bets</span>
                              </div>
                              <div
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                                onClick={()=>navigate("/sports_bets", { state: { active: 1 } })}
                              >
                                <span _ngcontent-feu-c67="">
                                  Casino Reports
                                </span>
                              </div>
                              <div
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                                onClick={()=>navigate("/sports_bets", { state: { active: 2 } })}
                              >
                                <span _ngcontent-feu-c67="">Fancy Reports</span>
                              </div>
                              <div
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                                onClick={()=>navigate("/sports_bets", { state: { active: 4 } })}
                              >
                                <span _ngcontent-feu-c67="">Results</span>
                              </div>
                            </div>
                          )}
                          <Link
                            _ngcontent-feu-c67=""
                            onClick={() => handleClick("account")}
                            className="dropDown_settings"
                          >
                            <img
                              _ngcontent-feu-c67=""
                              src="/assets/images/information.svg"
                              alt=""
                            />{" "}
                            Accounts{" "}
                            <div
                              _ngcontent-feu-c67=""
                              className="img-containers"
                            >
                              <img
                                _ngcontent-feu-c67=""
                                alt="dude"
                                src="/assets/images/arrow.png"
                                className="arrows mt-0 ng-star-inserted"
                                style={{
                                  transform:
                                    activeLink === "account"
                                      ? "rotate(90deg)"
                                      : "rotate(0deg)",
                                }}
                              />
                            </div>
                          </Link>
                          {activeLink === "account" && (
                            <div
                              _ngcontent-feu-c67=""
                              className="casinoesLink ng-star-inserted"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Link
                                to="/sports_bets" 
                                state={{ active: 3 }} 
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                              >
                                <span _ngcontent-feu-c67="">
                                  Account Statement
                                </span>
                              </Link>
                              {/* <Link
                        
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                              >
                                <span _ngcontent-feu-c67="">P&L Reports</span>
                              </Link> */}
                              <Link
                                to="/sports_bets" 
                                state={{ active: 3 }} 
                                _ngcontent-feu-c67=""
                                className="centered market-border ng-star-inserted py-1 py-2 rounded-3 row"
                                tabIndex="0"
                                style={{borderBottom: '1px solid #5e5a5a'}}
                              >
                                <span _ngcontent-feu-c67="">
                                  Deposit/Withdraw History
                                </span>
                              </Link>
                            </div>
                          )}

                          <Link
                            to="/changepassword"
                            _ngcontent-feu-c67=""
                            className="dropdown-item"
                          >
                            <img
                              _ngcontent-feu-c67=""
                              src="/assets/images/changepass.svg"
                              alt=""
                            />
                            Change Password
                          </Link>
                          <Link
                            to="/"
                            _ngcontent-feu-c67=""
                            className="dropdown-item"
                            onClick={() => {
                              setsidebaar(false);
                              logout();
                            }}
                            style={{ color: "#ff6767" }}
                          >
                            <img
                              _ngcontent-feu-c67=""
                              src="/assets/images/contactus.svg"
                              alt=""
                            />{" "}
                            Logout{" "}
                          </Link>
                          <div _ngcontent-feu-c67="" className="languages">
                            <div
                              _ngcontent-feu-c67=""
                              className="d-flex flex-column ml-2 mt-1"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </app-payment-method>
              )}

              {!isAuthenticated && (
               
                
                <div className="navigation-buttons" style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginRight:"6px"
                }}>
                  {/* <button 
                    className="demo-button"
                    style={{
                      backgroundColor: "#FFCC00",
                      color: "black",
                      borderRadius: "8px",
                      padding: "14px 20px",
                      border: "none",
                      fontWeight: "bold",
                      fontSize: "16px"
                    }}
                  >
                    Demo
                  </button> */}
                  
              <div className="right-navv mr-2"  >
              <button 
                    className="login-button-devansh"
                    onClick={() => {setactive(true); setregactive(false);}}
                    style={{
                      backgroundColor: "#fff",
                      color: "#000",
                      borderRadius: "8px",
                      padding: "2px 45px",
                      fontWeight:"bold",
                      border: "none",
                      display: "flex",
                      flexDirection:"column",
                      alignItems: "center",
                      justifyContent: "center",
                      
                     
                    }}
                  >
                   <i _ngcontent-feu-c67=""  className="bi bi-box-arrow-in-left sm-fs-15"  style={{color:"#000", fontSize: "1.2em" }}></i>
                    Login
                  </button>
                  
                  <button 
                    className="signup-button login-button-devansh"
                    onClick={()=>{setregactive(true); setactive(false)}}
                    
                    style={{
                      backgroundColor: "#FFCC00",
                      color: "black",
                      borderRadius: "0 8px 8px 0",
                      padding: "2px 46px",
                      border: "none",
                      fontWeight:"bold",
                     
                     
                      display: "flex",
                      flexDirection:"column",
                      alignItems: "center",
                      justifyContent: "center",
                     
                    }}
                  >
                   <i _ngcontent-feu-c67=""  className="bi bi-person-plus sm-fs-15" ></i>
                    Signup
                  </button>
              </div>
                </div>
              )}
            </ul>
          </app-nav-right>
        </div>
      </div>
    </>
  );
};